import { render, staticRenderFns } from "./ChooseCategory.vue?vue&type=template&id=72cc8f5a&scoped=true&"
import script from "./ChooseCategory.vue?vue&type=script&lang=js&"
export * from "./ChooseCategory.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCategory.vue?vue&type=style&index=0&id=72cc8f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cc8f5a",
  null
  
)

export default component.exports